import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsQuantitySelectorComponent } from "./ds-quantity-selector.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsQuantitySelectorComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsQuantitySelectorComponent],
})
export class DsQuantitySelectorModule {}
